var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBitcoin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 407,
    height: 348,
    viewBox: "0 0 407 348",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bitcoin_svg_02)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#bitcoin_svg_01)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 203,
    cy: 252,
    rx: 126,
    ry: 50,
    fill: "#A17B14"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75.2212 179.609H69.1738V204.024L69.607 206.775C74.6321 241.842 125.922 269.404 188.415 269.404C250.908 269.404 302.173 241.86 307.198 206.775L307.605 204.102V179.609H75.2212Z",
    fill: "#B58711",
    stroke: "#876200",
    strokeWidth: 0.89,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M328.835 158.915L337.248 163.738V182.995L328.835 178.181V158.915Z",
    fill: "#57FF67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.432 163.738L328.836 168.552V178.181L320.432 173.367V163.738Z",
    fill: "#122FDB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M312.027 130.021L320.431 134.844V173.367L312.027 168.553V130.021Z",
    fill: "#57FF67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.624 115.578L312.028 120.392V168.553L303.624 163.738V115.578Z",
    fill: "#122FDB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M295.211 120.392L303.624 125.206V163.738L295.211 158.915V120.392Z",
    fill: "#57FF67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.807 86.6833L295.211 91.4977V158.915L286.807 154.101V86.6833Z",
    fill: "#122FDB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M278.403 91.4978L286.807 96.3121V154.101L278.403 149.287V91.4978Z",
    fill: "#57FF67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.998 96.3118L278.402 101.126V149.286L269.998 144.472V96.3118Z",
    fill: "#122FDB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M261.587 72.2321L270 77.055V144.473L261.587 139.658V72.2321Z",
    fill: "#57FF67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.182 48.1605L261.586 52.9748V139.658L253.182 134.835V48.1605Z",
    fill: "#122FDB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M244.778 52.9746L253.182 57.7889V134.835L244.778 130.021V52.9746Z",
    fill: "#57FF67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.374 28.8943L244.778 33.7086V130.021L236.374 125.206V28.8943Z",
    fill: "#122FDB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M227.961 24.0803L236.374 28.8946V125.207L227.961 120.392V24.0803Z",
    fill: "#57FF67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.558 0L227.962 4.81431V120.392L219.558 115.578V0Z",
    fill: "#122FDB"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M305.923 184.681C305.75 184.251 305.568 183.822 305.386 183.409V173.359H299.079V172.646C297.428 170.451 295.636 168.363 293.716 166.396V173.359H290.103V162.931C288.422 161.418 286.629 159.939 284.723 158.495V173.376H281.119V155.881C279.386 154.695 277.59 153.549 275.73 152.443V173.393H272.143V150.328C270.41 149.348 268.573 148.411 266.737 147.499V173.359H263.167V145.849C261.382 145.041 259.571 144.264 257.735 143.519V173.385H254.148V149.176H248.707V173.368H245.172V155.813H239.714V173.359H236.196V162.45H230.755V173.359H227.29V169.061H221.797V173.359H155.31V169.061H149.808V173.359H146.343V162.45H140.833V173.359H137.315V155.813H131.848V173.359H128.322V149.176H122.872V173.368H119.32V143.476C117.483 144.215 115.675 144.989 113.896 145.797V173.359H110.327V147.456C108.479 148.356 106.674 149.299 104.912 150.285V173.342H101.334V152.374C99.4537 153.5 97.6516 154.661 95.9361 155.813V173.333H92.3319V158.435C90.4259 159.879 88.6411 161.366 86.9603 162.871V173.359H83.3388V166.37C81.4209 168.333 79.6297 170.415 77.9758 172.603V173.393H71.6685V182.661H69V204.025C69.7624 209.355 71.3393 216.232 74.3456 221.236V199.597L77.9758 203.337V227.288C79.6276 229.474 81.4189 231.553 83.3388 233.512V205.839H86.9343V236.985C88.6151 238.498 90.3999 239.969 92.3059 241.421V205.839H95.9101V244.018C97.6429 245.196 99.4277 246.356 101.308 247.457V205.839H104.886V249.554C106.619 250.526 108.455 251.471 110.301 252.374V205.839H113.87V254.059C115.647 254.867 117.457 255.649 119.294 256.389V205.839H122.846V257.756C124.64 258.426 126.45 259.062 128.296 259.673V205.839H131.822V260.799C133.624 261.349 135.452 261.874 137.289 262.364V205.839H140.807V263.275C142.62 263.722 144.445 264.143 146.282 264.539V205.839H149.748V265.235C151.567 265.59 153.401 265.92 155.249 266.224V205.839H158.715V266.765C160.552 267.035 162.391 267.275 164.234 267.487V205.839H167.699V267.866C169.536 268.046 171.381 268.21 173.227 268.339V205.839H176.692V268.597C178.538 268.7 180.392 268.777 182.237 268.837V205.839H185.703V268.88C187.563 268.88 189.431 268.88 191.309 268.88V205.839H194.774V268.803C196.628 268.74 198.476 268.66 200.319 268.562V205.804H203.785V268.304C205.639 268.167 207.475 268.012 209.321 267.831V205.839H212.786V267.487C214.635 267.264 216.471 267.02 218.297 266.757V205.839H221.762V266.224C223.608 265.923 225.436 265.588 227.255 265.235V205.839H230.721V264.522C232.563 264.132 234.391 263.713 236.205 263.266V205.839H239.722V262.355C241.559 261.856 243.379 261.332 245.181 260.782V205.839H248.716V259.656C250.552 259.045 252.372 258.409 254.157 257.739V205.839H257.709V256.363C259.546 255.612 261.356 254.836 263.141 254.033V205.839H266.711V252.34C268.547 251.428 270.349 250.491 272.117 249.511V205.839H275.704V247.465C277.587 246.319 279.383 245.158 281.093 243.983V205.839H284.697V241.378C286.603 239.934 288.396 238.455 290.077 236.942V205.839H293.69V233.478C295.61 231.513 297.401 229.428 299.053 227.236V202.572L302.692 196.175V220.754C305.291 216.267 306.625 208.77 307.578 204.119L308.037 184.699L305.923 184.681Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.389 247.904C254.23 247.904 307.605 217.327 307.605 179.609C307.605 141.891 254.23 111.315 188.389 111.315C122.548 111.315 69.1738 141.891 69.1738 179.609C69.1738 217.327 122.548 247.904 188.389 247.904Z",
    fill: "#FFD439"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.388 240.424C247.023 240.424 294.556 213.196 294.556 179.609C294.556 146.022 247.023 118.794 188.388 118.794C129.754 118.794 82.2207 146.022 82.2207 179.609C82.2207 213.196 129.754 240.424 188.388 240.424Z",
    fill: "#A27B14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.612 161.207C215.283 160.663 208.918 161.734 203.124 164.319C210.274 158.433 208.634 152.415 198.202 146.265L197.431 145.827C194.057 143.831 190.433 142.282 186.653 141.219C183.073 140.171 179.366 139.61 175.633 139.551C172.081 139.573 168.546 140.03 165.106 140.909C163.174 141.391 161.346 141.941 159.605 142.534L152.934 138.7L143.083 144.34L148.593 147.495C147.623 148.019 146.635 148.561 145.63 149.137L142.017 151.209L136.559 148.079L126.716 153.719L132.175 156.848L125.382 160.743L122.722 162.264L122.003 162.677L110.74 169.15L120.582 174.79L131.846 168.317L202.89 208.998L191.627 215.471L201.477 221.119L212.741 214.637L216.128 212.703L222.921 208.808L228.474 211.989L238.316 206.35L234.79 204.329L232.763 203.169L239.295 199.429L244.849 202.61L254.648 196.988L251.122 194.967L248.297 193.351C252.179 189.99 254.258 186.602 254.492 183.189C254.786 178.088 250.521 172.99 241.695 167.895L241.089 167.551C235.136 164.063 228.491 161.899 221.612 161.207ZM155.472 158.92L158.643 157.098C166.487 152.61 173.995 152.412 181.169 156.504C185.363 158.9 187.65 161.098 188.031 163.098C188.412 165.098 186.451 167.331 182.148 169.795L178.319 171.987L155.472 158.92ZM218.719 195.148L191.523 179.57L195.465 177.318C199.918 174.767 204.094 173.587 207.993 173.776C211.891 173.965 216.397 175.521 221.508 178.444C226.066 181.057 228.526 183.47 228.89 185.682C229.254 187.895 227.267 190.245 222.929 192.732L218.719 195.148Z",
    fill: "#FFD439"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.846 94.4038C203.785 94.4654 200.76 93.746 198.061 92.3147C195.617 90.922 194.274 89.0306 194.274 87.0018C194.274 84.9729 195.617 83.0901 198.052 81.6888C202.904 78.912 210.788 78.912 215.631 81.6888C218.074 83.0901 219.417 84.9729 219.417 87.0018C219.417 89.0306 218.057 90.9306 215.631 92.3147C212.931 93.7449 209.906 94.4642 206.846 94.4038ZM206.846 80.5626C203.952 80.5056 201.092 81.1833 198.537 82.5313C196.414 83.7521 195.245 85.3425 195.245 87.0104C195.245 88.6782 196.414 90.2772 198.537 91.4894C203.12 94.1201 210.571 94.1201 215.154 91.4894C217.277 90.2772 218.447 88.6868 218.447 87.0104C218.447 85.3339 217.277 83.7521 215.154 82.5313C212.599 81.1833 209.739 80.5056 206.846 80.5626Z",
    fill: "#FFD439"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.044 89.9935C210.432 90.802 208.651 91.2232 206.845 91.2232C205.039 91.2232 203.259 90.802 201.647 89.9935C198.779 88.3429 198.779 85.695 201.647 84.0272C203.259 83.2188 205.039 82.7976 206.845 82.7976C208.651 82.7976 210.432 83.2188 212.044 84.0272C214.92 85.6778 214.92 88.3429 212.044 89.9935Z",
    fill: "#57FF67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.195 72.5761L232.04 69.6274L240.817 64.5981L245.972 67.5469L237.195 72.5761Z",
    fill: "#57FF67"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M227.925 67.9081L221.427 66.0168L227.067 59.6808L233.565 61.5721L227.925 67.9081Z",
    fill: "#57FF67"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M216.592 65.1141L209.384 64.4607L211.333 57.437L218.533 58.0904L216.592 65.1141Z",
    fill: "#57FF67"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M204.298 64.4607L197.098 65.1141L195.157 58.0904L202.357 57.437L204.298 64.4607Z",
    fill: "#57FF67"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M192.263 66.0168L185.765 67.9081L180.125 61.5721L186.623 59.6808L192.263 66.0168Z",
    fill: "#57FF67"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M181.65 69.6274L176.495 72.5761L167.71 67.5469L172.874 64.5981L181.65 69.6274Z",
    fill: "#57FF67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.98 80.5197L218.169 79.4881L231.269 71.9829L233.08 73.0146L219.98 80.5197Z",
    fill: "#FFD439"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.838 78.5167L213.56 77.8461L221.964 68.3894L224.251 69.06L215.838 78.5167Z",
    fill: "#FFD439"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.813 77.339L208.283 77.1069L211.186 66.6272L213.715 66.8593L210.813 77.339Z",
    fill: "#FFD439"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.407 77.1069L202.868 77.339L199.975 66.8593L202.504 66.6272L205.407 77.1069Z",
    fill: "#FFD439"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.131 77.8461L197.852 78.5167L189.439 69.06L191.718 68.3894L200.131 77.8461Z",
    fill: "#FFD439"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.521 79.4881L193.701 80.5197L180.602 73.0146L182.412 71.9829L195.521 79.4881Z",
    fill: "#FFD439"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.013 81.8611L190.852 83.1679L174.339 78.3449L175.508 77.0382L192.013 81.8611Z",
    fill: "#FFD439"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.959 84.7409L189.552 86.1852L171.254 84.526L171.661 83.0731L189.959 84.7409Z",
    fill: "#FFD439"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.552 87.8356L189.959 89.2885L171.661 90.9477L171.263 89.4948L189.552 87.8356Z",
    fill: "#FFD439"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.852 90.8619L192.013 92.1687L175.508 96.983L174.339 95.6763L190.852 90.8619Z",
    fill: "#FFD439"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.701 93.5013L195.521 94.5416L182.412 102.047L180.602 101.007L193.701 93.5013Z",
    fill: "#FFD439"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M258.301 62.6382C277.561 75.9549 278.635 94.9801 261.55 108.942L268.481 115.278C292.055 98.4446 291.544 74.2097 266.947 57.6777L258.301 62.6382Z",
    fill: "#57FF67"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M217.268 124.794C196.891 126.625 175.326 123.075 159.627 114.056C156.202 112.124 153.005 109.817 150.097 107.179L138.349 109.509C142.131 113.199 146.387 116.378 151.007 118.965C170.856 130.331 198.658 134.371 224.147 131.096L217.268 124.794Z",
    fill: "#57FF67"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M128.705 93.4323L140.47 91.1111C138.391 80.0038 144.802 68.4752 159.626 59.9642C184.197 45.8824 223.15 45.0828 249.385 57.5313L258.049 52.5966C227.032 37.4315 180.394 38.2396 151.075 55.0381C132.76 65.5007 125.352 79.8233 128.705 93.4323Z",
    fill: "#57FF67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.637 112.303L195.036 109.663L254.115 75.8257L258.716 78.4564L199.637 112.303Z",
    fill: "#57FF67"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M206.178 116.051L201.577 113.412L227.248 98.7021L231.858 101.341L206.178 116.051Z",
    fill: "#57FF67"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M213.169 120.057L208.568 117.418L249.436 94L254.037 96.6393L213.169 120.057Z",
    fill: "#57FF67"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M220.049 123.995L215.448 121.355L247.262 103.13L251.871 105.769L220.049 123.995Z",
    fill: "#57FF67"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.878 74.397L165.387 75.5839C163.159 77.3574 161.524 79.235 160.612 81.6549C159.699 84.0803 159.432 87.2635 160.339 91.7776C161.156 95.8417 164.282 99.3584 168.072 102.14C171.825 104.894 175.935 106.709 178.162 107.448L179.973 108.049L178.765 111.654L176.954 111.053C174.408 110.208 169.927 108.223 165.806 105.198C161.721 102.2 157.688 97.9587 156.595 92.5229C155.593 87.5369 155.804 83.5951 157.037 80.3206C158.273 77.0404 160.456 74.643 163.002 72.6166L166.878 74.397Z",
    fill: "#57FF67"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "bitcoin_svg_01",
    x: 17,
    y: 142,
    width: 372,
    height: 220,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30,
    result: "effect1_foregroundBlur_326_4423"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bitcoin_svg_02"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 407,
    height: 348,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoin);
export default __webpack_public_path__ + "static/media/bitcoin.b58e94f4.svg";
export { ForwardRef as ReactComponent };